/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* The level of a particular path exclusion from ransomware detection. 
*/
export enum InfectedExcludePathLevel {
  INFECTED_EXCLUDE_PATH_LEVEL_UNSPECIFIED = 'UNSPECIFIED',
  INFECTED_EXCLUDE_PATH_LEVEL_GLOBAL = 'GLOBAL',
  INFECTED_EXCLUDE_PATH_LEVEL_EON_ACCOUNT = 'EON_ACCOUNT',
  INFECTED_EXCLUDE_PATH_LEVEL_RESOURCE = 'RESOURCE'
}
